import React, {useEffect, useRef, useState} from "react";
import track from "../services/track.service";
import TrackDataList from "../components/trackDataList";
import Loader from "../components/loader"
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {GoogleMap, InfoWindow, Marker, Polyline, useLoadScript} from "@react-google-maps/api";
import {Button,message,Switch, Modal} from "antd";
import {useScreenSize} from "../components/screensizeHook"

const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100%"
};

var defaultMapOptions = {
    streetViewControl: false,
    scaleControl: false,
    fullscreenControl: false,
    gestureHandling: "greedy",
    disableDoubleClickZoom: true,
    minZoom: 5,
    maxZoom: 20,
    mapTypeControl: false,
    zoomControl: true,
    clickableIcons: false,
}

const icon_size = 20;

export default function RaceTrack() {
    const {t} = useTranslation();
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: "AIzaSyBRHVJET38Cx1CGYAkiErRdKh7gi2V4etM"
    });
    // eslint-disable-next-line
    const [loading, set_loading] = useState(true);
    const [MarkerList, setMarkerList] = useState([]);
    const [MarkerList_ext, setMarkerList_ext] = useState([]);
    const [MPipeline, setPipeline] = useState([]);
    const [mapCenter, setMapCenter] = useState();
    // eslint-disable-next-line
    const [mapZoom, setMapZoom] = useState(5);
    const [mapOptions, setMapOptions] = useState(false);
    // eslint-disable-next-line
    const [selectedTrackUuid, setSelectedTrackUuid] = useState();
    const data_list_ref = useRef();
    const [map, setmap] = useState();
    const history = useHistory();
    const [showgate, setShowGate] = useState(true);
    const [showobstacle, setShowObstacle] = useState(false);
    const [showyards, setShowYards] = useState(false);
    const [trackcontent, setTrackContent] = useState("");
    const [user, setUser] = useState({});

    const add_track = () => {
        history.push("/track_form/");
    };

    const check_integrity = () =>
    {
        track.check_integrity().then((errors) => {
            if (errors.length > 0)
            {
                Modal.confirm({
                    title: 'Integrity check results',
                    icon: null,
                    content: <div className="integrity_cont">{errors.map((e,i) => <div key={'error_' + i}>{e}</div>)}</div>,
                    okCancel: false,
                    width: 700
                })
            }
            else
            {
                message.success("No problem found");
            }
        });
    };

    const onMapLoad = (map) => {
        setmap(map);
        map.setMapTypeId(window.google.maps.MapTypeId.SATELLITE);
        set_loading(false);
    };

    const setMarkers = () =>
    {
        let arrayMark = [];
        let arrayMark_ext = [];
        let labelPipeline = [];
        const lines = trackcontent.split(/\r?\n/);
        // remove empty line at the end
        if (lines[lines.length - 1].length === 0)
        {
            lines.pop();
        }
        let poscenter = {lat: 0, lng: 0, count: 0};
        for (let p = 1; p < lines.length; p++)
        {
            const values = lines[p].split(';');
            let posM = {
                lat: parseFloat(values[1]),
                lng: parseFloat(values[2]),
            };

            let posM_ext = {
                lat: parseFloat(values[5]),
                lng: parseFloat(values[6]),
            };

            poscenter.lat += posM.lat;
            poscenter.lng += posM.lng;
            poscenter.count++;

            if ((values[7].trim() === 'PCDEP' || values[7].trim() === 'PCARR') || (Number(values[7]) !== 0 && !values[7].trim().startsWith('PY') && parseInt(values[7].substr(2))))
            {
                arrayMark.push(
                    <Marker
                        key={`marker_${p}`}
                        position={posM}
                        icon={{
                            url: `/images/icons/green_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}>
                        <p>{values[7]}</p>
                        {
                            showgate &&
                            <InfoWindow position={posM} clickable={true}><p>{values[7]}</p></InfoWindow>
                        }
                    </Marker>
                );
                labelPipeline.push(<Polyline key={`polyline_${p}`} path={[posM, posM_ext]} strokeColor='pink' />);
                arrayMark_ext.push(
                    <Marker
                        key={`marker_ext_${p}`}
                        position={posM_ext}
                        icon={{
                            url: `/images/icons/green_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}
                    />
                );
            }
            else if (values[7].trim().startsWith("PCO"))
            {
                arrayMark.push(
                    <Marker
                        key={`marker_${p}`}
                        position={posM}
                        icon={{
                            url: `/images/icons/pink_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}>
                        <p>{values[7]}</p>
                        {
                            showobstacle &&
                            <InfoWindow position={posM} clickable={true}><p>{values[7]}</p></InfoWindow>
                        }
                    </Marker>
                );
                labelPipeline.push(<Polyline key={`polyline_${p}`} path={[posM, posM_ext]} options={{strokeColor:'#FF00B6', strokeOpacity: 1.0, strokeWeight: 2}} />);
                arrayMark_ext.push(
                    <Marker
                        key={`marker_ext_${p}`}
                        position={posM_ext}
                        icon={{
                            url: `/images/icons/pink_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}
                    />
                );
            }
            else if (values[7].trim().startsWith("PY"))
            {
                arrayMark.push(
                    <Marker
                        key={`marker_${p}`}
                        position={posM}
                        icon={{
                            url: `/images/icons/yellow_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}>
                        <p>{values[7]}</p>
                        {
                            showyards &&
                            <InfoWindow position={posM} clickable={true}><p>{values[7]}</p></InfoWindow>
                        }
                    </Marker>
                );
                labelPipeline.push(<Polyline key={`polyline_${p}`} path={[posM, posM_ext]} options={{strokeColor:'#FAFF00', strokeOpacity: 1.0, strokeWeight: 2}} />);
                arrayMark_ext.push(
                    <Marker
                        key={`marker_ext_${p}`}
                        position={posM_ext}
                        icon={{
                            url: `/images/icons/yellow_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}
                    />
                );
            }
            else
            {
                arrayMark.push(
                    <Marker
                        key={`marker_${p}`}
                        position={posM}
                        icon={{
                            url: `/images/icons/blue_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}
                    />
                );

                arrayMark_ext.push(
                    <Marker
                        key={`marker_ext_${p}`}
                        position={posM_ext}
                        icon={{
                            url: `/images/icons/red_dot.png`,
                            scaledSize: new window.google.maps.Size(icon_size, icon_size)
                        }}
                    />
                );
            }
        }

        if (poscenter.count > 0)
        {
            poscenter.lat /= poscenter.count;
            poscenter.lng /= poscenter.count;
            setMapZoom(16);
            map.setCenter(new window.google.maps.LatLng(poscenter.lat, poscenter.lng));
        }
        setMarkerList(arrayMark);
        setMarkerList_ext(arrayMark_ext);
        setPipeline(labelPipeline);
    }

    useEffect(() =>
    {
        setMarkers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trackcontent, showgate, showobstacle, showyards]);

    const getTrack = async (uuid) => {
        track
            .getContent(uuid)
            .then((r) => { if (r.data.content) setTrackContent(r.data.content); })
            .catch((error) => { console.log(error); });
    }

    const selectTrackCallback = (trackUuid) => {
        setSelectedTrackUuid(trackUuid);
    }

    // useEffect ------------------------------------------------------

    useEffect(() => {
        if (window.google) {
            setMapOptions(defaultMapOptions);
            setMapCenter(JSON.parse(localStorage.getItem('mapDefaultCenter')));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.google]);

    useEffect(() => {
        if (map && selectedTrackUuid) {
            getTrack(selectedTrackUuid).then();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, selectedTrackUuid]);

    const screenSize = useScreenSize();
    useEffect(() => {
        var mode = screenSize.width < 1000 ? 'cooperative': 'greedy';
        if (map && defaultMapOptions.gestureHandling !== mode) {
            defaultMapOptions.gestureHandling = mode;
            map.setOptions({ gestureHandling: mode });
        }
    }, [screenSize, map]);

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('user')));
    // eslint-disable-next-line
    }, []);
    
    // render ---------------------------------------------------------
    if (!isLoaded) return <Loader />;

    return (
            <div className="pilotage_page_wrapper">
                <div className="pilotage_panel_data">
                    <div className="header">
                        <div className="sub_header_title">
                            <span className="subtitle">{t('Track.Subtitle')}</span>
                        </div>
                        {
                            user.roles && user.roles.includes("admin") &&
                            <>
                                <div className="sub_header_action">
                                    <Button onClick={add_track} size="small">{t('Track.AddButton')}</Button>
                                </div>
                                <div className="sub_header_action">
                                    <Button onClick={check_integrity} size="small">Check integrity</Button>
                                </div>
                            </>
                        }
                    </div>
                    <TrackDataList ref={data_list_ref} trackCallback={selectTrackCallback} user={user}/>
                </div>
                <div className="pilotage_panel_map">
                    <div className="pilotage_panel_map__gates">
                        <Switch onChange={(e) => {setShowGate(!showgate);}} checked={showgate}/>
                        <div>Afficher les gates</div>
                        <Switch onChange={(e) => {setShowObstacle(!showobstacle);}} checked={showobstacle}/>
                        <div>Afficher les obstacles</div>
                        <Switch onChange={(e) => {setShowYards(!showyards);}} checked={showyards}/>
                        <div>Afficher les yards</div>
                    </div>
                    <GoogleMap
                        id='parcoursMap'
                        mapContainerStyle={containerStyle}
                        zoom={mapZoom}
                        center={mapCenter}
                        onLoad={onMapLoad}
                        options={mapOptions}>
                        {MarkerList}
                        {MarkerList_ext}
                        {MPipeline}
                    </GoogleMap>
                </div>
            </div>
    );
}
